<div [@drawer]="{ value: (hideToolbar$ | async) ? 'leave' : 'enter', params: { from: 'translate(0, -100%)' }}"
     class="c-toolbar-institutional"
     [ngClass]="{ 'c-toolbar-institutional--solid': isToolbarSolid }">

  <a [routerLink]="['/']"
     fragment="inicio"
     title="voltar para o início"
     class="c-toolbar-institutional__logo">

    <img
      [src]="(isMobile$ | async) ? mobileLogoUrl : desktopLogoUrl"
      alt="Redação Nota 1000"
      class="c-toolbar-institutional__logo-img">
  </a>

  <ng-container *ngIf="!(isMobile$ | async)">
    <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
  </ng-container>


  <div *ngIf="!!user; else signInButton"
    class="c-toolbar-institutional__user o-media o-media--middle o-media--flush"
    [matMenuTriggerFor]="userMenuRef">

    <fa-icon
      class="o-media__img u-icon u-icon-lighter t-accent"
      [ngClass]="isMobile ? 'u-icon-medium' : 'u-icon-large'"
      [fixedWidth]="true"
      [icon]="['fas', 'user-circle']">
    </fa-icon>

    <div class="o-media__body"
         *ngIf="!(isMobile$ | async) && user">

      <fa-icon
        class="t-accent u-icon-medium u-icon-lighter u-margin-left-small"
        [icon]="['fas', 'angle-down']">
      </fa-icon>
    </div>

    <mat-menu
      #userMenuRef="matMenu"
      [overlapTrigger]="false"
      yPosition="below"
      xPosition="after"
      class="c-dropdown-menu">

      <span class="c-dropdown-menu__title">
        Olá {{ user.apelido || user.nome }}
      </span>

      <ng-container *ngFor="let link of userMenu">

        <a *ngIf="link.routerLink; else externalLink"
           mat-menu-item
           class="c-dropdown-menu__item"
           [redAnchor]="link"
           [routerLink]="link.routerLink"
           [fragment]="link.fragment"
           [queryParams]="link.queryParams"
           [queryParamsHandling]="link.queryParamsHandling">
        </a>

        <ng-template #externalLink>
          <a mat-menu-item class="c-dropdown-menu__item" [redAnchor]="link"></a>
        </ng-template>
      </ng-container>

    </mat-menu>
  </div>

  <ng-template #signInButton>
    <button matRipple
            class="c-toolbar-institutional__sign-in"
            id=" btn-entrar"
            (click)="openAuthOverlay()">
      Entrar <fa-icon class="u-margin-left-tiny" [icon]="['fas', 'sign-in-alt']"></fa-icon>
    </button>
  </ng-template>

  <button mat-ripple
          *ngIf="isMobile"
          class="c-toolbar-institutional__menu-icon"
          [ngClass]="{ 'c-toolbar-institutional__menu-icon--open' : isMenuOpen }"
          (click)="openMobileMenu()">

    <fa-icon [icon]="['fas', 'bars']"></fa-icon>
  </button>
</div>

<ng-template #menuTemplate>

  <button mat-ripple
          *ngIf="isMobile"
          class="c-toolbar-institutional__close-icon"
          (click)="closeMenuMobile()">

    <fa-icon [icon]="['fas', 'times']"></fa-icon>
  </button>

  <nav class="c-toolbar-institutional__menu o-list-inline"
       *ngIf="(!isMobile || isMenuOpen) && menu?.anchor?.length > 0"
       [ngClass]="{ 'c-toolbar-institutional__menu--mobile' : isMobile }"
       [@fade]="isMobile ? menuAnimationState : 'enter'"
       (@fade.done)="menuAnimationDone()">

    <ng-container *ngFor="let link of menu.anchor">

      <a *ngIf="link.routerLink; else externalLink"
         @fade
         matRipple
         class="c-toolbar-institutional__menu-item o-list-inline__item"
         [id]="link.id"
         [ngClass]="'t-' + link.slug"
         [redAnchor]="link"
         [routerLink]="link.routerLink"
         [fragment]="link.fragment"
         [queryParams]="link.queryParams"
         [queryParamsHandling]="link.queryParamsHandling"
         (click)="closeMenuMobile()">
      </a>

      <ng-template #externalLink>
        <a matRipple
           class="c-toolbar-institutional__menu-item o-list-inline__item"
           [ngClass]="'t-' + link.slug"
           [id]="link.id"
           [redAnchor]="link" (click)="closeMenuMobile()">
        </a>
      </ng-template>

    </ng-container>

  </nav>
</ng-template>
